var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prize-rules-container",style:({ backgroundColor: _vm.background })},[_c('span',{staticClass:"title"},[_vm._v("活动规则")]),_c('div',{staticClass:"rules-content",domProps:{"innerHTML":_vm._s(_vm.rule || _vm.t)}})])}
var staticRenderFns = []

export { render, staticRenderFns }